import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { IAccountType, PlanOption } from '../EmployerDashboard.types';

const useGetPlansQuery = () => {
  const { data, isLoading, error, isError } = useQuery([API_URL.ACCOUNT_USAGE_PLANS], () =>
    api.get(API_URL.ACCOUNT_USAGE_PLANS)
  );
  const formatted = useMemo<PlanOption[]>(() => {
    const currentData = data?.data;
    if (!currentData || !currentData.length) {
      return [];
    }
    const list =
      currentData.map(
        (item): PlanOption => ({
          id: `${item.plan_id || ''}`,
          name: item.plan_name || '',
          accountType: item.account_type as IAccountType,
        })
      ) || [];
    return list;
  }, [data?.data]);

  return {
    data: formatted,
    isLoading,
    error,
    isError,
  };
};

export default useGetPlansQuery;
